/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { SecondeResidenceDto } from '../models/seconde-residence-dto';
import { SecondeResidencePersonnePhysiqueDto } from '../models/seconde-residence-personne-physique-dto';


/**
 * Fonctions de gestion des secondes résidences d'une personne physique
 */
@Injectable({
  providedIn: 'root',
})
export class SecondesResidencesPersonnePhysiqueService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation secondesResidencesPersonnePhysiqueGetList
   */
  static readonly SecondesResidencesPersonnePhysiqueGetListPath = '/api/secondes-residences-personne-physique/list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des secondes résidences de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesPersonnePhysiqueGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesPersonnePhysiqueGetList$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<StrictHttpResponse<Array<SecondeResidencePersonnePhysiqueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesPersonnePhysiqueService.SecondesResidencesPersonnePhysiqueGetListPath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SecondeResidencePersonnePhysiqueDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des secondes résidences de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesPersonnePhysiqueGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesPersonnePhysiqueGetList(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<Array<SecondeResidencePersonnePhysiqueDto>> {

    return this.secondesResidencesPersonnePhysiqueGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SecondeResidencePersonnePhysiqueDto>>) => r.body as Array<SecondeResidencePersonnePhysiqueDto>)
    );
  }

  /**
   * Path part for operation secondesResidencesPersonnePhysiqueLoadList
   */
  static readonly SecondesResidencesPersonnePhysiqueLoadListPath = '/api/secondes-residences-personne-physique/load-list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des secondes résidences de la personne physique spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesPersonnePhysiqueLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secondesResidencesPersonnePhysiqueLoadList$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesPersonnePhysiqueService.SecondesResidencesPersonnePhysiqueLoadListPath, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des secondes résidences de la personne physique spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesPersonnePhysiqueLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secondesResidencesPersonnePhysiqueLoadList(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.secondesResidencesPersonnePhysiqueLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation secondesResidencesPersonnePhysiqueGet
   */
  static readonly SecondesResidencesPersonnePhysiqueGetPath = '/api/secondes-residences-personne-physique/{personnePhysiqueId}/{secondeResidenceId}';

  /**
   * Renvoie la seconde résidence spécifiée pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesPersonnePhysiqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesPersonnePhysiqueGet$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;
  }): Observable<StrictHttpResponse<SecondeResidencePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesPersonnePhysiqueService.SecondesResidencesPersonnePhysiqueGetPath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('secondeResidenceId', params.secondeResidenceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SecondeResidencePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie la seconde résidence spécifiée pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesPersonnePhysiqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesPersonnePhysiqueGet(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;
  }): Observable<SecondeResidencePersonnePhysiqueDto> {

    return this.secondesResidencesPersonnePhysiqueGet$Response(params).pipe(
      map((r: StrictHttpResponse<SecondeResidencePersonnePhysiqueDto>) => r.body as SecondeResidencePersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation secondesResidencesPersonnePhysiqueDelete
   */
  static readonly SecondesResidencesPersonnePhysiqueDeletePath = '/api/secondes-residences-personne-physique/{personnePhysiqueId}/{secondeResidenceId}';

  /**
   * Dissocie la seconde résidence spécifiée de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesPersonnePhysiqueDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesPersonnePhysiqueDelete$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesPersonnePhysiqueService.SecondesResidencesPersonnePhysiqueDeletePath, 'delete');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('secondeResidenceId', params.secondeResidenceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Dissocie la seconde résidence spécifiée de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesPersonnePhysiqueDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  secondesResidencesPersonnePhysiqueDelete(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;
  }): Observable<void> {

    return this.secondesResidencesPersonnePhysiqueDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation secondesResidencesPersonnePhysiquePost
   */
  static readonly SecondesResidencesPersonnePhysiquePostPath = '/api/secondes-residences-personne-physique/{personnePhysiqueId}';

  /**
   * Associe la seconde résidence spécifiée à la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secondesResidencesPersonnePhysiquePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secondesResidencesPersonnePhysiquePost$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Seconde résidence
     */
    body: SecondeResidenceDto
  }): Observable<StrictHttpResponse<SecondeResidencePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, SecondesResidencesPersonnePhysiqueService.SecondesResidencesPersonnePhysiquePostPath, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SecondeResidencePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Associe la seconde résidence spécifiée à la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `secondesResidencesPersonnePhysiquePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secondesResidencesPersonnePhysiquePost(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Seconde résidence
     */
    body: SecondeResidenceDto
  }): Observable<SecondeResidencePersonnePhysiqueDto> {

    return this.secondesResidencesPersonnePhysiquePost$Response(params).pipe(
      map((r: StrictHttpResponse<SecondeResidencePersonnePhysiqueDto>) => r.body as SecondeResidencePersonnePhysiqueDto)
    );
  }

}
